module.exports = __webpack_public_path__ + "img/hfd.06a92bb9.png";